import React, { useContext, useEffect, useState } from "react";
import { UserServiceContext } from "../services/user/userService";
import Loader from "../components/Loader";
import CustomAlert from "../components/CustomAlert";
import ReactDataTable from "react-data-table-component";
import { paginationComponentOptions } from "../utils/constants";
import { IconTrash, IconEye, IconBook } from "@tabler/icons-react";
import NotificationModal from "./app/modals/Notification";

const Notifications = () => {
  const {
    getNotifications,
    notifications,
    loading,
    notificationDeactivate,
    notificationsRead,
  } = useContext(UserServiceContext);

  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const [id, setId] = useState(null);

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });

  const handleModalShow = () => {
    setOpenNotificationModal(!openNotificationModal);
    fetchNotifications();
  };

  const fetchNotifications = async () => {
    await getNotifications();
  };

  const handleDeleteNotification = async (id) => {
    const data = [id];
    setAlertConfig({
      show: true,
      title: "დარწმუნებული ხართ?",
      text: "გსურთ ამ შეტყობინების წაშლა?",
      icon: "warning",
      showConfirmButton: true,
      onConfirm: async () => {
        await notificationDeactivate(data);
        setAlertConfig({ ...alertConfig, show: false });
        fetchNotifications();
      },
      onCancel: () => {
        setAlertConfig({ ...alertConfig, show: false });
      },
    });
  };

  const readAllNotification = async () => {
    const data = notifications
      ?.filter((item) => item.messageIsOpened === false)
      .map((item) => item.id);

    if (data.length === 0) {
      setAlertConfig({
        show: true,
        title: "შეტყობინებები",
        text: "თქვენ არ გაქვთ წაუკითხავი შეტყობინება",
        icon: "warning",
        showConfirmButton: false,
        onCancel: () => {
          setAlertConfig({ ...alertConfig, show: false });
        },
      });
      return;
    }

    await notificationsRead(data);
    fetchNotifications();
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const conditionalRowStyles = [
    {
      when: (row) => row.messageIsOpened === false,
      style: {
        backgroundColor: "#b9b3a8 !important",
        color: "white !important",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  ];

  const columns = [
    { name: "სახელი", selector: (row) => row.name },
    {
      name: "თარიღი",
      selector: (row) => {
        const date = new Date(row.scheduleDate);
        return date.toLocaleDateString("ka-GE", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
      },
    },
    { name: "ტექსტი", selector: (row) => row.text },
    {
      cell: (row) => (
        <button
          className="btn btn-outline-danger"
          style={{ color: row.messageIsOpened ? "#b9b3a8" : "inherit" }}
          onClick={() => {
            setId(row.id);
            setOpenNotificationModal(!openNotificationModal);
          }}
        >
          <IconEye />
        </button>
      ),
      width: "70px",
      style: { cursor: "pointer" },
    },
    {
      cell: (row) => (
        <button
          className="btn btn-outline-danger"
          style={{ color: row.messageIsOpened ? "#b9b3a8" : "inherit" }}
          onClick={() => handleDeleteNotification(row.id)}
        >
          <IconTrash />
        </button>
      ),
      width: "70px",
      style: { cursor: "pointer" },
    },
  ];

  return (
    <>
      {loading && <Loader />}
      <CustomAlert {...alertConfig} />
      {openNotificationModal && (
        <NotificationModal onClose={handleModalShow} id={id} />
      )}
      <div className="md:px-6 sm:px-3 pt-4">
        <div className="flex items-center justify-between gap-4 flex-wrap mx-20 my-20">
          <h5 className="text-[20px]/[26px]"></h5>
          <div className="flex items-stretch gap-1 flex-wrap">
            <button
              className="btn btn-outline-secondary"
              onClick={() => readAllNotification()}
            >
              <IconBook className="w-[18px] h-[18px]" />
              <span className="sm:block hidden">ყველას წაკითხვა</span>
            </button>
            {/* <button className="btn btn-outline-secondary">
              <IconCloudDownload className="w-[18px] h-[18px]" />
              <span className="sm:block hidden">ექსპორტი</span>
            </button> */}
          </div>
        </div>
        <div className="container-fluid">
          <div className="react-data-table mt-20">
            <ReactDataTable
              columns={columns}
              pagination
              striped
              data={notifications}
              paginationComponentOptions={paginationComponentOptions}
              conditionalRowStyles={conditionalRowStyles}
              noDataComponent={
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "gray",
                  }}
                >
                  შეტყობინებები არ გაქვთ
                </div>
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Notifications;
